export default __webpack_public_path__ + "static/media/hot-16.ef8bbcbe.png";